module.exports = __webpack_public_path__ + "img/gengxinshijian.7aa9b2bf.png";